import Popover from 'antd/lib/popover';
import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import * as React from 'react';
import { antGrey, runwayColors } from '../styles/globalStyles';
import { AlignLeftOutlined, ThunderboltFilled } from '@ant-design/icons';
import MarkdownComponent from '../HOCs/Markdown';

const DESCRIPTION_FONT_SIZE = 12;
const DESCRIPTION_POPOVER_MAX_WIDTH = 360;
const DESCRIPTION_POPOVER_MAX_HEIGHT = 320;

export const MonitoringMetricDescriptionIcon: React.FC<{ description: string }> = ({ description }) => (
    <Popover
        content={
            <div
                className="metric-description-markdown"
                style={{
                    maxWidth: DESCRIPTION_POPOVER_MAX_WIDTH,
                    maxHeight: DESCRIPTION_POPOVER_MAX_HEIGHT,
                    overflowY: 'auto',
                }}
            >
                <MarkdownComponent source={description} style={{ fontSize: DESCRIPTION_FONT_SIZE }} />
            </div>
        }
    >
        <AlignLeftOutlined style={{ color: antGrey.grey7, fontSize: 10 }} />
    </Popover>
);

export const renamedMetricTooltip = (
    customDisplayName: string | undefined,
    generatedTitle: string,
    isDisplayNameTruncated = false,
) =>
    customDisplayName ?
        isDisplayNameTruncated ? `${customDisplayName} (${generatedTitle})`
        :   generatedTitle
    :   undefined;

export const generateAutomationThunderboltIcon: (args: {
    isUsedForAutoAccelerate: boolean;
    isUsedForAutoHalt: boolean;
    prefix?: string;
}) => React.ReactNode = ({ isUsedForAutoAccelerate, isUsedForAutoHalt, prefix }) => {
    return (
        (isUsedForAutoAccelerate || isUsedForAutoHalt) && (
            <Tooltip
                title={() => {
                    if (isUsedForAutoAccelerate && isUsedForAutoHalt) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Release stable phased releases to 100% of users</strong> and{' '}
                                <strong>the Halt unstable phased releases</strong> automations.
                            </Typography.Text>
                        );
                    } else if (isUsedForAutoAccelerate) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Release stable phased releases to 100% of users</strong> automation.
                            </Typography.Text>
                        );
                    } else if (isUsedForAutoHalt) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Halt unstable phased releases</strong> automation.
                            </Typography.Text>
                        );
                    }

                    return null;
                }}
            >
                <ThunderboltFilled style={{ color: runwayColors.primary }} />
            </Tooltip>
        )
    );
};
